export const CHANNEL_SOURCE = {
    casinoClient: 'CASINO_CLIENT',
    partyJackpotToaster: 'PARTY_JACKPOT_TOASTER',
    omg: 'OMG',
    myAccount: 'MY_ACCOUNT',
    registration: 'REGISTRATION'
}

export const CHANNEL_ELEMENTS = {
    depositButton: 'deposit_button',
    withdrawButton: 'withdraw_button',
    retryButton: 'retry_button',
    plusButton: 'plus_button',
    urlParam: 'url_param',
    deepLink: 'deep_link'
}

export const DISPLAY_MESSAGE_IDS = {
    sofRequired: 100,
    retryCloseDrawerMessage: 101,
    psRedirectFocusDialog: 102,
    timeSpentReminder: 104 // BI said it should be 104
}